<template>
  <div>
    <AppInputSearch
      :loading="loading"
      :show-reset-button="searchText !== null"
      @reset="reset"
    >
      <AppInput
        v-model="searchText"
        type="search"
        placeholder="Search apps & URLs"
        :debounce="250"
        @input="evaluateQuery"
      />
    </AppInputSearch>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'SettingsInsightsSearch',
  data: () => ({
    searchText: null,
  }),
  computed: {
    ...mapState(['query', 'loading']),
  },
  created() {
    this.initQuery();
  },
  methods: {
    ...mapActions(['setQuery']),
    initQuery() {
      const queryParams = new URLSearchParams(window.location.search);

      if (queryParams.has('search')) {
        this.searchText = queryParams.get('search');
        this.search();
      }
    },
    search() {
      if (this.query !== this.searchText) {
        this.setQuery({ search: this.searchText });
      }
    },
    evaluateQuery() {
      if (this.searchText === '') {
        this.search();
        this.reset();
      } else {
        this.search();
      }
    },
    reset() {
      this.searchText = null;
      this.search();
    },
  },
};
</script>
